import { render, staticRenderFns } from "./VGauge.vue?vue&type=template&id=5cf4099e&scoped=true"
import script from "./VGauge.vue?vue&type=script&lang=js"
export * from "./VGauge.vue?vue&type=script&lang=js"
import style0 from "./VGauge.vue?vue&type=style&index=0&id=5cf4099e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf4099e",
  null
  
)

export default component.exports